export enum PlayerWidgetType {
  normal = 'normal',
  compact = 'compact',
}

export enum InfoWidgetType {
  title = 'title',
  normal = 'normal',
  small = 'small',
}

export enum SmartLinkWidgetType {
  info = 'info',
  image = 'image',
  link = 'link',
  socialLinks = 'socialLinks',
  profile = 'profile',
  player = 'player',
  presave = 'presave',
  /** A picture or a video of the song (the Media block, 2026-10-08). It replaces `image` for new blocks. */
  media = 'media',
  /** "Get every release" (Pre-save Subscriptions, 2026-10-10): a fan opts in to every future release. */
  presaveSubscribe = 'presaveSubscribe',
}
